import "../assets/css/about.css";

export default function About() {
  return (
    <div className="about-page">

      {/* VISION SECTION */}
      <section className="vision-section">
        <div className="container">
          <h2 className="section-title">Company Vision</h2>
          <p className="vision-text">
            "To be the leader in holistic health, offering innovative and accessible homeopathic, nutraceutical, herbal, and cosmetic solutions that empower individuals to achieve optimal well-being and embrace natural health."
          </p>
        </div>
      </section>

      {/* DIRECTORS MESSAGE SECTION */}
      <section className="directors-section">
        <div className="container">
          <h2 className="section-title">Director's Messages</h2>

          <div className="directors-grid">

            {/* Director 1 */}
            <div className="director-card">
              <img 
                src="/assets/director_1.png" 
                alt="Director 1" 
                className="director-photo"
              />
              <h3 className="director-name">Mr. Manoj Gupta</h3>
              <p className="director-message">
                “Focusing on the quality and credibility of our services is an essential part of who we are and how we conduct our business. As Phil Crosby said, <i>‘Quality is the result of a carefully constructed cultural environment. It has to be the fabric of the organization, not part of the fabric.’</i>
                <br/><br/>
                Inspired by this belief, we started with a dream: to provide the people of Homoeopathy with better opportunities in life, along with new avenues of exposure in the market and the emerging era of homoeopathy.”
              </p>
            </div>

            {/* Director 2 */}
            <div className="director-card">
              <img 
                src="/assets/director_2.png" 
                alt="Director 2" 
                className="director-photo"
              />
              <h3 className="director-name">Mr. Pradeep Saxena</h3>
              <p className="director-message">
                "At R Vibes Homoeopathy Pvt. Ltd., we have built our identity on rigorous homoeopathic craftsmanship and years of disciplined industry experience. <br/><br/>Our approach combines the classical principles of homoeopathy with structured research, authenticated sources, and controlled potentisation to ensure every remedy reflects purity, stability, and therapeutic integrity. We operate with a clear philosophy: natural medicine must be transparent, ethically produced, and scientifically governed. <br/><br/>Every step of our process, from raw-material verification to final quality checks, is executed with precision to uphold the safety and trust of patients and practitioners.
As we expand into homoeopathic formulations, nutraceuticals, herbal preparations, and personal care solutions, our commitment remains unwavering to deliver dependable, accessible, and high-quality natural healthcare rooted in evidence, responsibility, and genuine care.<br/><br/> Our work is driven by a culture where quality is not an achievement, but a continuous discipline that defines who we are."
              </p>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}
